import Median from 'median-js-bridge';

export const setLocalAccessToken = (token: string): string => {
	try {
		Median.storage.app.set({
			key: 'BIGGBY_ACCESS_TOKEN',
			value: token
		});
		return token;
	} catch (err) {
		throw new Error('failed to set local access token');
	}
};
export const setLocalRefreshToken = (token: string): string => {
	try {
		Median.storage.app.set({
			key: 'BIGGBY_REFRESH_TOKEN',
			value: token
		});
		return token;
	} catch (err) {
		throw new Error('failed to set local refresh token');
	}
};

export const getLocalAccessToken = async (): Promise<string> => {
	// return new Promise(resolve)
	const token = await Median.storage.app.get({
		key: 'BIGGBY_ACCESS_TOKEN'
	});
	if (!token || !token.data) {
		throw new Error('no token found');
	}
	return token.data;
};

export const getLocalRefreshToken = async (): Promise<string> => {
	const token = await Median.storage.app.get({
		key: 'BIGGBY_REFRESH_TOKEN'
	});

	if (!token || !token.data) {
		throw new Error('no token found');
	}
	return token.data;
};

export const setLocalUserId = (userId: string): string => {
	try {
		Median.storage.app.set({
			key: 'BIGGBY_USER_ID',
			value: userId
		});
		return userId;
	} catch (err) {
		throw new Error('Unable to set User ID');
	}
};

export const getLocalUserId = async (): Promise<number> => {
	const token = await Median.storage.app.get({
		key: 'BIGGBY_USER_ID'
	});

	if (!token || !token.data) {
		throw new Error('no user ID found');
	}
	return Number(token.data);
};

export const deleteLocalInfo = (): void => {
	Median.storage.app.deleteAll({ statuscallback: deleteCallback });
	function deleteCallback(result: any) {
		if (result.status) {
			console.log(result.status);
		}
	}
};
